<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark" fixed="bottom">
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-button class="mr-3" variant="success" size="sm">ORDER IDD++</b-button>
            <b-button class="mr-3" variant="warning" size="sm">ORDER EDD</b-button>
            <b-button class="mr-3" variant="info" size="sm">SEND DDQ</b-button>
            <b-button class="mr-3" variant="primary" size="sm">SEND POLICY</b-button>
            <b-button class="mr-3" variant="danger" size="sm">SEND TRAIN</b-button>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
export default {
  name: "FooterComponent",
  data() {
    return {};
  }
};
</script>